import * as React from 'react';
import { Route, RouteComponentProps } from 'react-router';
import { LoginCallbackView } from './LoginCallbackView';
import { LoginView } from './LoginView';
import { RenewCallbackView } from './RenewCallbackView';

export interface IAccountProps extends RouteComponentProps<undefined> {}

export class AccountView extends React.Component<IAccountProps> {
    public render() {
        return (
            <>
                <Route path="/account/spa-login" component={LoginView} />
                <Route path="/account/spa-login-callback" component={LoginCallbackView} />
                <Route path="/account/spa-renew-callback" component={RenewCallbackView} />
            </>
        );
    }
}
